/* eslint-disable */
import React from "react";
import { Commodities } from "../../../controls/Commodities";
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";

interface ControlItem {
  id: string;
  name: string;
  group: string | undefined;
  olap_commodity: number;
  comment: string | undefined;
}

export const CommoditiesControl: React.FC = () => {
  const [groupsItems, setGroupsItems] = React.useState<ControlItem[]>([]);
  const [items, setItems] = React.useState<ControlItem[]>([]);
  const [business] = useParameter<any>("@business-units");
  const [paramGroup, setParamGroup] = useParameter<number[]>("@commodities_groups");
  const [param, setParam] = useParameter("@commodities");
  const [dictItems] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    business_unit: Number(business),
    slide: 4,
  });

  React.useEffect(() => {
    if (dictItems) {
      const nextItems = dictItems.map<ControlItem>((x) => ({
        id: String(x.id),
        name: (x.getValue("name") as any)[9] as string,
        group: (x.getValue<number | null>("group") || undefined)?.toString(),
        olap_commodity: Number(x.getValue<number>("olap_commodity")),
        comment: (x.getValue<string | null>("comment") || undefined)?.toString(),
      }));
      setItems(nextItems.filter((x) => Boolean(x.group)));
      const groups = nextItems.filter((x) => !Boolean(x.group));
      setGroupsItems(groups);

      if (paramGroup && !groups.find((g) => Number(g.id) === paramGroup?.[0])) {
        setParamGroup([Number(groups[0].id)]);
      }
    }
  }, [dictItems]);

  const onChange = React.useMemo(
    () => (value) => {
      setParamGroup([Number(value[0])]);
      const group = groupsItems.find((x) => x.id === value[0]);
      const commodities = items.filter((x) => group && x.group === group.id);
      setParam(commodities.map((x) => x.olap_commodity));
    },
    [dictItems, groupsItems]
  );
  const res = React.useMemo(() => {
    const value = [String(paramGroup)];
    return <Commodities items={groupsItems} value={value} onChange={onChange} />;
  }, [groupsItems, paramGroup, JSON.stringify(param), onChange]);
  if (!items?.length) {
    return <Skeleton variant="rect" width="168px" height="51px" />;
  }
  return res;
};
